import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import Layout from "./Layout";
import { api, setCsrfToken } from "../lib/api";
const AuthContext = createContext(null);
export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) {
        // Outside ProtectedLayout (login screen). Default to viewer so no
        // admin-only UI accidentally renders.
        return { user: "anon", role: "viewer" };
    }
    return ctx;
}
export default function ProtectedLayout() {
    const [state, setState] = useState("loading");
    const [auth, setAuth] = useState(null);
    useEffect(() => {
        api
            .whoami()
            .then((r) => {
            setCsrfToken(r.csrf_token);
            const role = r.role === "admin" || r.role === "operator" || r.role === "viewer"
                ? r.role
                : "viewer";
            setAuth({ user: r.user, role });
            setState("authed");
        })
            .catch(() => setState("unauthed"));
    }, []);
    if (state === "loading") {
        return (_jsx("div", { style: {
                display: "grid",
                placeItems: "center",
                height: "100vh",
                color: "#64748b",
            }, children: "Checking session\u2026" }));
    }
    if (state === "unauthed" || auth === null) {
        return _jsx(Navigate, { to: "/login", replace: true });
    }
    return (_jsx(AuthContext.Provider, { value: auth, children: _jsx(Layout, {}) }));
}
